export const MEMBER_TAG_SYMBOL = '@';
export const LOCATION_TAG_SYMBOL = '📍';
export const START_OF_HEADING_UNICODE = '\u0001';
